export default "__VITE_ASSET__CPSbNZgp__"